export const useFSTrackEvent = () => {
  const trackEvent = (name: string, properties: object = {}) => {
    window.FS?.('trackEvent', {
      name,
      properties,
    })
  }
  return { trackEvent }
}
